export const Master_List_of_Reports_Array = {
	Performance_Summary_Total: {
		customizable: true,
		reportIds: [1, 8],
		compReports: {
			curr: "Performance_Summary_current",
			prev: "Performance_Summary_previous",
		},
		inReport: true,
		reportType: "verticalComp",
		sortBy: "reportType",
		position: "start",
		limit: 3,
		titleDisplay: "Performance Summary",
		headers: [
			{
				value: "selectedTime",
				format: "string",
				label: "Compared Dates",
				comp: false,
				addClass: "",
			},
			{
				label: "# of Adjustments",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "# of Adjustments",
			},
			{
				label: "# of Mobile Sales",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "# of Mobile Sales",
			},
			{
				label: "# of Sales",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "# of Sales",
			},
			{
				label: "Ad Impressions",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "Ad Impressions",
			},
			{
				label: "Average Sale Amount",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "Average Sale Amount",
			},
			{
				label: "CPC Earnings",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "CPC Earnings",
			},
			{
				label: "Click Through Rate",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "Click Through Rate",
			},
			{
				label: "Click Throughs",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "Click Throughs",
			},
			{
				label: "Commissions",
				format: "dolalr",
				comp: true,
				adClass: "small-cell",
				value: "Commissions",
			},
			{
				label: "Conversion Rate",
				format: "percent",
				comp: true,
				adClass: "small-cell",
				value: "Conversion Rate",
			},
			{
				label: "Date",
				format: "string",
				comp: true,
				adClass: "small-cell",
				value: "Date",
			},
			{
				label: "Incentives",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "Incentives",
			},
			{
				label: "Merchant",
				format: "string",
				comp: true,
				adClass: "small-cell",
				value: "Merchant",
			},
			{
				label: "Mobile Sales",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "Mobile Sales",
			},
			{
				label: "Network CPC Earnings",
				format: "dolalr",
				comp: true,
				adClass: "small-cell",
				value: "Network CPC Earnings",
			},
			{
				label: "Network Commissions",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "Network Commissions",
			},
			{
				label: "New Customer %",
				format: "percent",
				comp: true,
				adClass: "small-cell",
				value: "New Customer %",
			},
			{
				label: "New Customer Sales",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "New Customer Sales",
			},
			{
				label: "New Customers",
				format: "int",
				comp: true,
				adClass: "small-cell",
				value: "New Customers",
			},
			{
				label: "Sales",
				format: "dollar",
				comp: true,
				adClass: "small-cell",
				value: "Sales",
			},
			{
				label: "Weekday",
				format: "string",
				comp: true,
				adClass: "small-cell",
				value: "Weekday",
			},
		],
	},
	Performance_Summary_By_Day_Graph: {
		ids: [12],
		inReport: true,
		customizable: false,
		compReports: {
			curr: "Performance_Summary_By_Day_current",
			prev: "Performance_Summary_By_Day_previous",
		},
		reportType: "graph",
		titleDisplay: "Performance Summary By Day",
		headers: [
			{ value: "Sales", label: "Sales", format: "currency" },

			{
				value: "Conversion Rate",
				label: "Conversion Rate",
				format: "percent",
			},
		],
	},

	Performance_Summary_By_Affiliate: {
		reportIds: [15],
		compReports: {
			curr: "Performance_Summary_By_Affiliate_current",
			prev: "Performance_Summary_By_Affiliate_previous",
		},
		inReport: true,
		reportType: "horizontalComp",
		sortBy: "Sales",
		joinKey: "Affiliate Id",
		position: "flex",
		customizable: true,
		titleDisplay: "Performance Summary by Affiliate",
		headers: [
			{
				value: "Affiliate Name",
				format: "string",
				label: "Affiliate Name",
				comp: false,
				addClass: "",
			},
			{
				value: "Affiliate Id",
				format: "string",
				label: "Affiliate Id",
				comp: false,
				addClass: "",
			},
			{
				addClass: "name-cell",
				comp: false,
				label: "Affiliate Category",
				format: "string",
				value: "Affiliate Category",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Ad Impressions",
				format: "int",
				value: "Ad Impressions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Click Throughs",
				format: "int",
				value: "Click Throughs",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Sales",
				format: "dollar",
				value: "Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Sales",
				format: "int",
				value: "# of Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Mobile Sales",
				format: "int",
				value: "# of Mobile Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Mobile Sales",
				format: "dollars",
				value: "Mobile Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Adjustments",
				format: "int",
				value: "# of Adjustments",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customers",
				format: "int",
				value: "New Customers",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customer Sales",
				format: "dollar",
				value: "New Customer Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Commissions",
				format: "dollar",
				value: "Commissions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Incentives",
				format: "dollar",
				value: "Incentives",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Network Commissions",
				format: "dollar",
				value: "Network Commissions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Conversion Rate",
				format: "percent",
				value: "Conversion Rate",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Average Sale Amount",
				format: "dollar",
				value: "Average Sale Amount",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customer %",
				format: "percent",
				value: "New Customer %",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Click Through Rate",
				format: "percent",
				value: "Click Through Rate",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Affiliate Tags",
				format: "string",
				value: "Affiliate Tags",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "AOV",
				format: "dollar",
				value: "AOV",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Total Spend",
				format: "string",
				value: "Total Spend",
			},

			{
				value: "ROA",
				format: "dollar",
				label: "ROA",
				comp: true,
				addClass: "small-cell",
			},
		],
	},
	Performance_Summary_By_Affiliate_Website: {
		reportIds: [20],
		compReports: {
			curr: "Performance_Summary_By_Affiliate_Website_current",
			prev: "Performance_Summary_By_Affiliate_Website_previous",
		},
		inReport: true,
		reportType: "horizontalComp",
		sortBy: "Sales",
		joinKey: "Affiliate Id",
		position: "flex",
		customizable: true,
		titleDisplay: "Performance Summary By Affiliate Website",
		headers: [
			{
				value: "Affiliate Website Name",
				format: "string",
				label: "Affiliate Website Name",
				comp: false,
				addClass: "name-cell",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "CPC Earnings",
				format: "dollar",
				value: "CPC Earnings",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Network CPC Earnings",
				format: "dollar",
				value: "Network CPC Earnings",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Placement Earnings",
				format: "dollar",
				value: "Placement Earnings",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Network Placement Earnings",
				format: "dollar",
				value: "Network Placement Earnings",
			},
			{
				addClass: "small-cell",
				comp: false,
				label: "Website Id",
				format: "string",
				value: "Website Id",
			},
			{
				addClass: "small-cell",
				comp: false,
				label: "Affiliate Id",
				format: "string",
				value: "Affiliate Id",
			},

			{
				addClass: "name-cell",
				comp: false,
				label: "Affiliate Website",
				format: "string",
				value: "Affiliate Website",
			},
			{
				addClass: "small-cell",
				comp: false,
				label: "Website Category",
				format: "string",
				value: "Website Category",
			},
			{
				addClass: "name-cell",
				comp: false,
				label: "Affiliate Category",
				format: "string",
				value: "Affiliate Category",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Ad Impressions",
				format: "int",
				value: "Ad Impressions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Click Throughs",
				format: "int",
				value: "Click Throughs",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Sales",
				format: "dollar",
				value: "Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Sales",
				format: "int",
				value: "# of Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Mobile Sales",
				format: "int",
				value: "# of Mobile Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Mobile Sales",
				format: "dollars",
				value: "Mobile Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "# of Adjustments",
				format: "int",
				value: "# of Adjustments",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customers",
				format: "int",
				value: "New Customers",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customer Sales",
				format: "dollar",
				value: "New Customer Sales",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Commissions",
				format: "dollar",
				value: "Commissions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Incentives",
				format: "dollar",
				value: "Incentives",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Network Commissions",
				format: "dollar",
				value: "Network Commissions",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Conversion Rate",
				format: "percent",
				value: "Conversion Rate",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Average Sale Amount",
				format: "dollar",
				value: "Average Sale Amount",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "New Customer %",
				format: "percent",
				value: "New Customer %",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Click Through Rate",
				format: "percent",
				value: "Click Through Rate",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Affiliate Tags",
				format: "string",
				value: "Affiliate Tags",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "AOV",
				format: "dollar",
				value: "AOV",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "Total Spend",
				format: "string",
				value: "Total Spend",
			},
			{
				addClass: "small-cell",
				comp: true,
				label: "ROA",
				format: "dollar",
				value: "ROA",
			},
		],
	},
	Performance_Summary_By_Sub_Affiliate_Partner: {
		reportIds: [96],
		compReports: {
			curr: "Performance_Summary_By_Sub_Affiliate_Partners_current",
			prev: "Performance_Summary_By_Sub_Affiliate_Partners_previous",
		},
		inReport: true,
		customizable: true,
		reportType: "horizontalComp",
		sortBy: "Sales",
		joinKey: "Affiliate Id",
		position: "flex",
		titleDisplay: "Performance Summary by Sub Affiliate Partner",
		headers: [
			{
				value: "Sub Affiliate Domain",
				format: "string",
				label: "Sub Affiliate Domain",
				comp: false,
				addClass: "name-cell",
			},
			{
				value: "Affiliate Name",
				format: "string",
				label: "Affiliate Name",
				comp: false,
				addClass: "border-right",
			},
			{
				value: "Click Throughs",
				format: "int",
				label: "Click Throughs",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Sales",
				format: "dollar",
				label: "Sales",
				comp: true,
				addClass: "small-cell",
			},

			{
				value: "# of Sales",
				format: "int",
				label: "# of Sales",
				comp: true,
				addClass: "small-cell",
			},

			{
				value: "Commissions",
				format: "dollar",
				label: "Commissions",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Conversion Rate",
				format: "percent",
				label: "Conversion Rate",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "AOV",
				format: "dollar",
				label: "AOV",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Total Spend",
				format: "dollar",
				label: "Total Spend",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "ROA",
				format: "dollar",
				label: "ROA",
				comp: true,
				addClass: "small-cell",
			},
		],
	},
};

// Product_Sold_List: {
// 	customizable: false,
// 	reportIds: 18,
// 	inReport: true,
// 	sortBy: "Total Product Sale Quantity",
// 	joinKey: "Product Name",
// 	titleDisplay:"",headers: {
// 		"Product Name": { yoy: false, dataType: "string" },
// 		"Product SKU": { yoy: false, dataType: "string" },
// 		"Sale Count ": { yoy: true, dataType: "currency" },
// 		"Total Product Sale Amount": { yoy: true, dataType: "currency" },
// 	},
// },

// },
// Product_Performance_By_Departments_and_Brands: {
// 	customizable: false,
// 	reportIds: 18,
// 	inReport: true,
// 	sortBy: "Total Product Sale Quantity",
// 	joinKey: "Product Name",
// 	titleDisplay:"",headers: {
// 		"Brand Name": { yoy: false, dataType: "string" },
// 		Category: { yoy: false, dataType: "string" },
// 		Department: { yoy: false, dataType: "string" },
// 		Merchant: { yoy: false, dataType: "string" },
// 		"Product Name": { yoy: false, dataType: "string" },
// 		"Product SKU": { yoy: false, dataType: "string" },
// 		"Sale Count ": { yoy: true, dataType: "currency" },
// 		"Sub Category": { yoy: false, dataType: "string" },
// 		"Total Product Sale Amount": { yoy: true, dataType: "currency" },
// 		"Total Product Sale Quantity": { yoy: true, dataType: "int" },
// 	},
// },
